// Self-hosted architectural plates. Nothing on the site loads an image from another host.
// Dimensions are the files' real pixel sizes, so the browser can reserve space and avoid layout shift.
// To replace a plate, overwrite the .webp in public/images and update its width and height here.
const plate = (file, width, height) => ({
  src: `${process.env.PUBLIC_URL}/images/${file}.webp`,
  width,
  height,
});

const IMAGES = {
  tower: plate('tower-dusk', 1280, 1920),
  skyline: plate('skyline-blue-hour', 2400, 1350),
  atrium: plate('atrium-limestone', 2200, 1238),
  facade: plate('facade-mullions', 1600, 1600),
  colonnade: plate('colonnade-limestone', 1280, 1920),
  boardroom: plate('boardroom-city', 2200, 1238),
  between: plate('between-towers', 1280, 1920),
  entrance: plate('entrance-bronze', 2200, 1238),
};

export default IMAGES;
